/* eslint-disable max-len */
import { configureStore } from '@reduxjs/toolkit'
import { persistReducer,persistStore } from "redux-persist"
import storage from 'localforage'
import systemConfigSlice from './systemConfigSlice';
import { organizationusersList } from '../slices/apiSlice';
import  usersSlice from  '../pages/ManagePatient/ViewPatient/userSlice'
import monitorsSlice from '../pages/ManagePatient/TopBar/monitorsSlice';
import MultiselectRows from "./MultiselectRows"
import MultiselectRowsConditionally from "./MultiselectRowsConditionally"
import commonSlice from "./commonSlice"
import authSlice from '../pages/auth/authSlice';
import wellnessFilterSlice from './wellnessFilterSlice';
import wellnessFilterUserSlice from './wellnessFilterUserSlice';
import wellnessFilterOrganizationSlice from './wellnessFilterOrganizationSlice';
import wellnessFilterProviderSlice from './wellnessFilterProviderSlice';
import patientSearchSlice from './patientSearchSlice'
import deviceAlertSearchSlice from './deviceAlertReportSearchSlice'
import AlertNotificationSearchSlice from './alerAndNotificationSearchSlice'
import deviceAlertDashboardSearchSlice from './deviceAleartDashboardSlice'
import DashboardSearchSlice from './dashboardSearchSlice'
import apiMiddleware from './SystemConfigCallMiddleWare';
import wellnessReportSearchSlice from './wellnessReportSearchSlice';


const persistConfig = {
    key: 'root', // key for the storage
    storage, // storage engine to use
    
};
const patientSearchPersistConfig = {
    key: 'patientSearchData',
    storage,
};

const deviceAlertSearchPersistConfig = {
    key: 'deviceAlertSearchData',
    storage,
};

const AlertNotificationSearchPersistConfig = {
    key: 'AlertNotificationSearchData',
    storage,
};

const deviceAlertDashboardSearchPersistConfig = {
    key: 'deviceAlertDashboardSearchData',
    storage,
};

const DashboardSearchPersistConfig = {
    key: 'DashboardSearchData',
    storage,
};

const wellnessReportPersistConfig = {
    key: 'WellnessReportSearchData',
    storage,
};

const persistedReducer = persistReducer(persistConfig, systemConfigSlice);
const persistedPatientSearchReducer = persistReducer(patientSearchPersistConfig, patientSearchSlice);
const persistedDeviceAlertSearchReducer = persistReducer(deviceAlertSearchPersistConfig, deviceAlertSearchSlice);
const persistedAlertNotificationSearchReducer = persistReducer(AlertNotificationSearchPersistConfig, AlertNotificationSearchSlice);
const persistedDeviceAlertDashboardSearchReducer = persistReducer(deviceAlertDashboardSearchPersistConfig, deviceAlertDashboardSearchSlice);
const persistedDashboardSearchReducer = persistReducer(DashboardSearchPersistConfig, DashboardSearchSlice);
const persistedWellnesReportSearchReducer = persistReducer(wellnessReportPersistConfig, wellnessReportSearchSlice);


export const store = configureStore({
    reducer: {
        [organizationusersList.reducerPath]:organizationusersList.reducer,
        auth: authSlice,
        systemConfigData:persistedReducer,
        commonData:commonSlice,
        MultiSelectSlice:MultiselectRows, 
        monitorsSelect:monitorsSlice,
        filterSelect:wellnessFilterSlice,
        filterUserNameSelect:wellnessFilterUserSlice,
        filterOrgNameSelect:wellnessFilterOrganizationSlice,
        filterProviderNameSelect:wellnessFilterProviderSlice,
        // subdivSelect:subdivisionSlice,
        deviceAlertSearchData: persistedDeviceAlertSearchReducer,
        MultiSelectSliceConditionally: MultiselectRowsConditionally,
        patientSearchData: persistedPatientSearchReducer,
        AlertNotificationSearchData: persistedAlertNotificationSearchReducer,
        deviceAlertDashboardSearchData: persistedDeviceAlertDashboardSearchReducer,
        DashboardSearchData: persistedDashboardSearchReducer,
        WellnessReportSearchData:persistedWellnesReportSearchReducer,

    },
    middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware(),
        apiMiddleware,
        organizationusersList.middleware,
    ],
    
})

export const persistor = persistStore(store);